import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLeads2 from './AdminLeads2';
import AdminLayout from './AdminLayout';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Leads2PortalProvider } from '../../contexts/Leads2PortalContext';

const AdminLeads2Page = () => {
  const navigate = useNavigate();
  const { adminToken, adminUser } = useAdminAuth();
  const value = {
    token: adminToken,
    role: 'admin',
    basePath: '/admin/leads2',
    currentUserId: adminUser?.id || null,
    currentUserName: adminUser ? `${adminUser.firstName || ''} ${adminUser.lastName || ''}`.trim() : null,
    Layout: AdminLayout,
  };
  return (
    <Leads2PortalProvider value={value}>
      <AdminLeads2 onNavigateDetail={(leadId) => navigate(`/admin/leads2/${leadId}`)} />
    </Leads2PortalProvider>
  );
};

export default AdminLeads2Page;
